import axiosInstance from "./axiosInstance";

const apiUrl = process.env.REACT_APP_API_URL;

export const getTicketsApi = async (offset = 0) => {
  return axiosInstance.get(`/api/tickets/?offset=${offset}`);
};

export const getCustTicketsApi = async (cmpid, custid) => {
  const response = await axiosInstance.get(
    `${apiUrl}/api/get_tickets_by_customer?companytransid=${cmpid}&customertransid=${custid}`,
  );
  return response;
};

export const getDetailTicketByTcode = async (tcode) => {
  const response = await axiosInstance.get(
    `${apiUrl}/api/tickets/activities/${tcode}/`,
  );
  return response;
};

export const saveTicketActivity = async (mydata) => {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/api/save_ticket_activity/`,
      mydata,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

//// arwa saveticket api:
export const postSaveTicket = async (ticketData) => {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/api/save_ticket/`,
      ticketData,
    );
    return response.data;
  } catch (error) {
    console.error("Error saving ticket:", error.message);
    throw error;
  }
};

/// notes panel api:
export const saveNotes = async (noteData) => {
  const response = await axiosInstance.post(
    `${apiUrl}/api/ticket-note/`,
    noteData,
  );
  return response;
};

/// timespent panel api:
export const saveTimeSpent = async (tsData) => {
  const response = await axiosInstance.post(
    `${apiUrl}/api/save_ticket_time_spent/`,
    tsData,
  );
  return response;
};

export const getTimeSpentById = async (tid) => {
  const response = await axiosInstance.get(
    `${apiUrl}/api/ticket-timespent/${tid}/`,
  );
  return response;
};

export const updateTimeSpent = async (editData, tid) => {
  const response = await axiosInstance.put(
    `${apiUrl}/api/update-ticket-time-spent/${tid}/`,
    editData,
  );
  return response;
};

// komal
export async function deleteTimeSpent(ticketcode) {
  const response = await axiosInstance.delete(
    `${apiUrl}/api/delete-ticket-time-spent/${ticketcode}/`,
  );
  return response.data;
}

export const getcustcategory = async (cmpid, custid) => {
  const response = await axiosInstance.get(
    `${apiUrl}/api/category-subcategory-mapping/?companyid=${cmpid}&custid=${custid}`,
  );
  return response.data;
};

export const getStatusApi = async () => {
  const response = await axiosInstance.get(`${apiUrl}/api/get_ticket_status/`);
  return response.data.data;
};

export const getPriorityApi = async () => {
  const response = await axiosInstance.get(`${apiUrl}/api/priorities/`);
  return response.data.data; // return pure array
};

//API to get closed Ticket details
export const getTicketTimeAnalysis = async (ticketCode) => {
  const response = await axiosInstance.get(
    `${apiUrl}/api/ticket-time-analysis/${ticketCode}/`,
  );
  return response;
};

//api to save ticket-reply
export const saveReply = async (data) => {
  const response = await axiosInstance.post(
    `${apiUrl}/api/save_ticket_reply/`,
    data,
  );
  return response;
};

// get ticket activities-replies (includes replies)
export const getTicketActivities = async (ticketcode) => {
  const response = await axiosInstance.get(
    `${apiUrl}/api/tickets/activities/${ticketcode}/`,
  );
  return response;
};

export const getTicketDevelopers = async (ticketCode) => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/api/ticket-developers/${ticketCode}/`,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: error?.response?.data || error.message,
    };
  }
};
